export enum ChainId {
  UNSET = 0,
  BINANCE_MAINNET = 56,
  BINANCE_TESTNET = 97,
  CSC_MAINNET = 52,
  CSC_TESTNET = 53,
  OKC_MAINNET = 66,
  OKC_TESTNET = 65,
  POLYGON_MAINNET = 137,
  POLYGON_TESTNET = 80001,
}

export enum Wallet {
  Metamask = "Metamask",
  TrustWallet = "Trust Wallet",
  WalletConnect = "WalletConnect",
  OKX = "OKX Wallet",
}

export enum NetworkName {
  UNSET = "TBA",
  BINANCE_MAINNET = "BNB Chain",
  BINANCE_TESTNET = "BNB Chain Testnet",
  CSC_MAINNET = "CSC",
  CSC_TESTNET = "CSC Testnet",
  OKC_MAINNET = "OKC",
  OKC_TESTNET = "OKC Testnet",
  POLYGON_MAINNET = "Polygon",
  POLYGON_TESTNET = "Polygon Testnet",
}

export enum LinkName {
  Telegram = "telegram",
  Twitter = "twitter",
  Website = "website",
  Discord = "discord",
  Instagram = "instagram",
  Medium = "medium",
  Document = "document",
  Bscscan = "bscscan",
  Pitchdeck = "pitchdeck",
  Whitepaper = "whitepaper",
  Tokenomics = "tokenomics",
}

export enum SocialLinkName {
  Telegram = "telegram",
  Twitter = "twitter",
  Website = "website",
  Discord = "discord",
  Instagram = "instagram",
  Medium = "medium",
  Document = "document",
  Bscscan = "bscscan",
}

export enum DocsLinkName {
  Pitchdeck = "pitchdeck",
  Whitepaper = "whitepaper",
  Tokenomics = "tokenomics",
}

export enum Language {
  EN = "en",
  RU = "ru",
}

export enum TierName {
  TIER_1 = "Earth",
  TIER_2 = "Orbit",
  TIER_3 = "Galaxy",
  TIER_4 = "Universe",
}

export enum TierRequiredAmount {
  TIER_1 = "0",
  TIER_2 = "2000",
  TIER_3 = "5000",
  TIER_4 = "20000",
}
